<ui-title [title]="'SOD Clash Checker'"></ui-title>


<div class="col-lg-12">
	<form class="mb-4">
		<div class="form-group">

			<ui-input-autocompleter
				#autocompleterUsers
				[text]="'Search User'"
				[controller]="self"
				[autocompleteDisplay]="autocompleteDisplaySelectedUsername"
				[searchObservable]="search_sor_users"
			></ui-input-autocompleter>


		</div>

		<div class="form-group" style="padding-top: 10px;">
			<ui-input-autocompleter
				#autocompleterRoles
				[text]="'Search Role'"
				[controller]="self"
				[multiple]="true"
				
				[autocompleteDisplay]="autocompleteDisplaySelectedRole"
				[searchObservable]="search_roles"
				(valueChange)="selectedRolesChange($event)"
				[userSelectedRoles]="selectedRoles"
			></ui-input-autocompleter>
			<div *ngIf="selectedRoles.length>0" >
			<p>selected Roles Count : {{selectedRoles.length}} </p>
			<ul>
				<li *ngFor="let item of selectedRoles">
					{{item.System.Name+' - '+item.MappedName+' ('+item.Name+')'}}
				</li>
			</ul>
			</div>
		</div>
      <div style="padding-top: 10px;">
		<button mat-button class="{{autocompleterUsers.formControl.value && selectedRoles.length>0?'btn-primary':'btn-disabled'}}" (click)="sodcheck_doCheck()">Check</button>
		&nbsp;&nbsp;
		<button mat-button class="{{autocompleterUsers.formControl.value && selectedRoles.length>0?'btn-primary':'btn-disabled'}}" (click)="sodcheck_Clear()">Clear</button>
	  </div>

	</form>
	<ui-loading [loading]="sodcheck.loading" [loadingText]="'checking for SOD clash'"></ui-loading>

<div *ngIf="sodcheckReponse.length>0">
	<ul class="nav nav-tabs"  >
		<li class="nav-item">
    <button
      class="nav-link fw-bold text-danger"
      [class.active]="activeTab === 'clash'"
      (click)="activeTab = 'clash'">
      SOD Clash detected ({{activeCount(true)}})
    </button>
  </li>
    <li class="nav-item">
    <button
      class="nav-link active fw-bold text-primary"
      [class.active]="activeTab === 'noClash'"
      (click)="activeTab = 'noClash'">
      No SOD Clash detected ({{activeCount(false)}})
    </button>
  </li>
  
</ul>

<div class="tab-content mt-3">
  <div *ngIf="activeTab === 'noClash'" class="tab-pane fade show active">
    <table class="table ui-table" *ngIf=" activeCount(false)>0 && !sodcheck.loading" >
		<thead>
		<tr>
			<th>User Name</th>
			<th>Role Name</th>
			<th>Comment</th>
		</tr>
		</thead>
		<tr *ngFor="let item of sodcheckReponse" >
			<td *ngIf="!item.Clash && !sodcheck.loading">{{sodcheck.userAsText}}</td>
			<td *ngIf="!item.Clash && !sodcheck.loading">{{geSelectedRoleName(item.RoleId)}}</td>
			<td *ngIf="!item.Clash && !sodcheck.loading">No SOD Clash detected </td>
		</tr>
	</table>

	<p class="alert alert-success" *ngIf="activeCount(false)==0 && !sodcheck.loading">
		No SOD Clash found for the User <b>{{sodcheck.userAsText}}</b>
	</p>
  </div>
  <div *ngIf="activeTab === 'clash'" class="tab-pane fade show active">
   	<div *ngFor="let item of sodcheckReponse">
	<p class="alert alert-danger" *ngIf="item.Clash && !sodcheck.loading">
		This User <b>{{sodcheck.userAsText}}</b> and Role <b>{{geSelectedRoleName(item.RoleId)}}</b> combination breaches one or more SOD Clash rules:

	<table class="table ui-table" *ngIf="item.Clash && !sodcheck.loading">
		<thead>
		<tr>
			<th>System</th>
			<th>Standard Role Name</th>
			<th>Role Name</th>
		</tr>
		</thead>
		<tr *ngFor="let clash of item.ClashWith">
			<td>{{clash.System.Name}}</td>
			<td>{{clash.MappedName}}</td>
			<td>({{clash.Name}})</td>
		</tr>
	</table>
	</div>
	<p class="alert alert-success" *ngIf="activeCount(true)==0 && !sodcheck.loading">
		 SOD Clash not detected for this User <b>{{sodcheck.userAsText}}</b>
	</p>
  </div>
</div>
</div>	
</div>
